import * as React from 'react';
import { SVGProps } from 'react';

const SvgChat = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.272 2.005 11.962 2H8.712C3.893 2 0 5.578 0 9.971c0 1.627.533 3.18 1.517 4.495l.08.165 1.328 4.888 4.633-1.276-.27-.576-.186-.41-3.42.993-.928-3.722-.058-.076a7.456 7.456 0 0 1-1.503-4.16l-.007-.32c0-4.028 3.224-6.884 7.527-6.884h3.248c2.179 0 4.23.747 5.803 2.068h-.002l.145.123a8.084 8.084 0 0 0-.143-.123h1.14L18.774 5c-1.567-1.795-3.922-2.912-6.502-2.995Zm2.152 4.403c-3.908 0-7.077 3.19-7.077 7.125s3.169 7.125 7.077 7.125h2.498l4.715 1.424 1.122-4.517A7.126 7.126 0 0 0 24 13.533c0-3.935-3.169-7.125-7.078-7.125h-2.498Zm0 .98h2.498c3.367 0 6.098 2.75 6.098 6.145a6.147 6.147 0 0 1-.916 3.242l-.154.238-.1.145-.915 3.687-3.868-1.166h-2.643c-3.366 0-6.097-2.75-6.097-6.146 0-3.32 2.611-6.023 5.874-6.141l.223-.004Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgChat;
